import Notification from '../notification/notification';
import ModalPromo from '../modal-promo/modal-promo';
import ModalSubscription from '../modal-subscription/modal-subscription';

export default new class promoInputBlock {
  constructor() {
    this.promoInputBlock = '.promo-input-block';
    this.promoCodeAmount = '.promo-input-block__promo-amount';
    this.footerPrice = '.subscription__footer-total-val';
    this.topPrice = '.subscription__head-price-val';
    this.applyPromoBtn = '.js-apply-promo';
    this.cancelPromoBtn = '.js-cancel-promo';
    this.formInput = '.form-item__input';
    this.oldPrice = '.subscription__discount-price';

    this.promCodeAmountBlock = '.promo-input-block__promo-count';

    this.activeClass = '_active';
    this.disableClass = '_disable';
    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    $(document)
    // apply promo click
      .on('click', this.applyPromoBtn, (e) => {
        const $applyPromoBtn = $(e.currentTarget);
        const $promoInput = $applyPromoBtn.closest(this.promoInputBlock).find(this.formInput);
        const $cancelPromoBtn = $(this.cancelPromoBtn);
        const promoCode = $promoInput.val().trim();

        if ($applyPromoBtn.hasClass(this.disableClass)) return;

        $applyPromoBtn.addClass(this.disableClass);

        $.request('UserPromoCode::onCheckCode', {
          data: {
            code: promoCode,
            tariff_id: ModalSubscription.tariffId,
          },
          success: (response) => {
            if (!response || !response.status) {
              // error apply promo
              Notification.showError(response.message);
            } else {
              // success apply promo response
              this.togglePromoBtns($cancelPromoBtn, $applyPromoBtn);
              this.setPromoPrice(response.data);
              ModalPromo.togglePromo(null, promoCode, true);

              // set promo code disabled
              this.togglePromoCode(promoCode, false);
              // this.setPromoCodesAmount();

              $(this.promoInputBlock).addClass(this.activeClass);
            }
            // enable apply promo btn
            $applyPromoBtn.removeClass(this.disableClass);
          },
        });
      })
    // cancel promo click
      .on('click', this.cancelPromoBtn, (e) => {
        const $cancelPromoBtn = $(e.currentTarget);
        const $promoInput = $cancelPromoBtn.closest(this.promoInputBlock).find(this.formInput);
        const $applyPromoBtn = $(this.applyPromoBtn);
        const promoCode = $promoInput.val();

        if ($cancelPromoBtn.hasClass(this.disableClass)) return;

        $cancelPromoBtn.addClass(this.disableClass);

        // set promo btn enable, show apply btn, hide cancel btn
        ModalPromo.togglePromo(null, promoCode, false);

        this.togglePromoCode(promoCode, true);
        // this.setPromoCodesAmount();

        // success cancel promo response
        this.togglePromoBtns($applyPromoBtn, $cancelPromoBtn);
        $(this.oldPrice).text(''); // clear old price
        this.setDefaultPrice(); // set default price
        $(this.promoInputBlock).removeClass(this.activeClass);
      });
  }


  /**
     * Set default price, without discount
     */
  setDefaultPrice() {
    const defaultPrice = $(this.topPrice).attr('data-price');

    // set default price without discount at the bottom of page
    $(this.footerPrice).text(defaultPrice);

    // set default price without discount at the top of page
    $(this.topPrice).text(defaultPrice);
  }

  /**
     * Set promo price with discount
     *
     * @param promoPrice - string, promo price
     */
  setPromoPrice(promoPrice) {
    $(this.oldPrice).text($(this.footerPrice).text()); // set old price
    $(this.footerPrice).text(promoPrice); // set new total price
    $(this.topPrice).text(promoPrice); // set new total price in the top of page
  }

  /**
     * Show/hide promo btns
     *
     * @param $btnToShow
     * @param $btnToHide
     */
  togglePromoBtns($btnToShow, $btnToHide) {
    $btnToHide.removeClass(this.disableClass);
    $btnToHide.removeClass(this.activeClass);
    $btnToShow.addClass(this.activeClass);
  }

  /**
     *
     * @param promoCode
     * @param promoAmount
     */
  pastePromo(promoCode, promoAmount) { // eslint-disable-line no-unused-vars
    const $promoInput = $(this.promoInputBlock).find(this.formInput);

    $promoInput.val(promoCode);
    $(this.applyPromoBtn).trigger('click');
    // this.setPromoCodesAmount(promoAmount);
  }

  /**
     * Set actual amount of available promoCodes
     */
  // setPromoCodesAmount () {
  //     let amount = ModalPromo.getPromoAmount();
  //
  //     if (amount > 0) {
  //         $(this.promoCodeAmount).text(amount);
  //         $(this.promCodeAmountBlock).show();
  //     } else {
  //         $(this.promCodeAmountBlock).hide();
  //     }
  // }

  /**
     * Clear promo input, enable apply and show promo button,
     * hide cancel promo button, refresh available promo code amount
     */
  resetPromoBlock() {
    const $promoInput = $(this.promoInputBlock).find(this.formInput);
    const $applyPromoBtn = $(this.applyPromoBtn);
    const $cancelPromoBtn = $(this.cancelPromoBtn);

    this.togglePromoBtns($applyPromoBtn, $cancelPromoBtn);
    $promoInput.val('');
    // this.setPromoCodesAmount();
  }

  /**
     * Set promo code disable/enable in personal-area_promo and in promo code modal
     *
     * @param promoCode - number
     * @param isEnable - boolean
     */
  togglePromoCode(promoCode, isEnable) {
    const $personalAreaPromoCode = $(ModalPromo.PersonalDataPromoContainer).find(`.promo-item[data-promo="${promoCode}"]`);
    const $modalPromoPromoCode = $(ModalPromo.modalPromo).find(`.promo-item[data-promo="${promoCode}"]`);

    if (isEnable) {
      $personalAreaPromoCode.removeClass('_disabled');
      $modalPromoPromoCode.removeClass('_disabled');
    } else {
      $personalAreaPromoCode.addClass('_disabled');
      $modalPromoPromoCode.addClass('_disabled');
    }
  }
}();
